import React, { Component } from 'react';
import {FocusOn} from 'react-focus-on';
import Welcome from './Welcome/Welcome';
import { hexToRgb } from 'utils/hexToRgb';
import { withTranslation } from 'react-i18next';
import './WelcomePopUp.scss';
import { CaptureHigherEd } from '../../utils/captureHigherEdHelpers';

class WelcomePopUp extends Component {
  constructor() {
    super();
    this.state = {
      activeIndex: 0,
      show: true,
      restart: false,
      activeElement: null,
    };
  }

  componentDidMount() {
    const { show } = this.state;
    const { captureHigherEdTrackingId } = this.props;

    if (captureHigherEdTrackingId) {
      CaptureHigherEd.connect(captureHigherEdTrackingId);
      CaptureHigherEd.logPageView();
    }

    const aframe = document.getElementById('scene');

    if (aframe) aframe.style.position = 'unset';
    if (show) document.addEventListener('keydown', this.handleEscapeKey);
  }

  setCustomStyles = () => {
    const {
      tour: {
        styles: { primaryColor },
      },
    } = this.props;
    if (primaryColor)
      return { backgroundColor: '#f8f8f8', color: primaryColor };
  };

  closePopUp = () => {
    this.setState({ show: false });
  };

  render() {
    const {
      videos,
      tier,
      tour: {
        name,
        description,
        enablePopUpVideo,
        popUpVideoId,
        styles: { primaryColor },
      },
      t,
    } = this.props;
    const { show } = this.state;

    if (!show) return null;
    return (
      <FocusOn>
        <div id="welcome-modal" className="welcome-modal">
          <section
            className="welcome-modal-content"
            style={{
              backgroundColor: hexToRgb(primaryColor) || 'rgba(0, 0, 0, 0.6)',
              marginBottom: tier === 'starter' && 85,
            }}
            aria-label={t('publicTour.ada.welcome.welcomeModalLabel')}
            data-cy="welcome-modal-content"
          >
            <Welcome
              closePopUp={this.closePopUp}
              description={description}
              enablePopUpVideo={enablePopUpVideo}
              name={name}
              popUpVideoId={popUpVideoId}
              restart={this.restart}
              setCustomStyles={this.setCustomStyles}
              videos={videos}
            />
          </section>
        </div>
      </FocusOn>
    );
  }
}

export default withTranslation()(WelcomePopUp);
